import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { map, noop } from 'lodash';

import SelectableRecordTable from 'components/selectable_record_table/selectable_record_table';
import PeopleTableHeader from '../people_table_header';
import PersonRow from '../person_row';

import { getDuplicatePeople } from '../../store/selectors/duplicates';
import { getSelectedPersonIds } from '../../store/selectors/select_list';

export function DuplicatesTable({ duplicates, selectedPersonIds }) {
  const isSelected = person => selectedPersonIds.includes(person.id);

  const renderPeople = () => (
    map(duplicates, person => (
      <PersonRow
        canPreview={() => false}
        key={person.id}
        person={person}
        selected={isSelected(person)}
        updatePreviewOverlay={noop}
      />
    ))
  );

  return (
    <SelectableRecordTable
      columnHeaders={<PeopleTableHeader allowSort={false} />}
      hasSelectAll={false}
    >
      {renderPeople()}
    </SelectableRecordTable>
  );
}

DuplicatesTable.propTypes = {
  duplicates: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired
  })).isRequired,
  selectedPersonIds: PropTypes.arrayOf(PropTypes.number).isRequired
};

const mapStateToProps = state => ({
  duplicates: getDuplicatePeople(state),
  selectedPersonIds: getSelectedPersonIds(state)
});

export default connect(mapStateToProps)(DuplicatesTable);
